module.exports = __webpack_public_path__ + "d546005b14494ce1498d600d9a3ca5aa.svg";